export const messages = {
  en: {
    sellingCostDetail: {
      queryCondition: 'Query Conditions',
      sellingCostDetail: 'Selling Cost Details',
      productId: 'Product ID',
      productName: 'Product Name',
      barCode: 'Bar Code',
      totalAmount: 'Amount',
      returnCartNum: 'Return Quantity',
      returnPayPrice: 'Return Amount',
      actualCartNum: 'Actual Sales Quantity',
      salesRevenue: 'Sales Revenue',
      salesCost: 'Cost',
      grossMargin: 'Gross Margin',
      lossAmount: 'Loss Amount',
      createTime: 'Create Time',
      total: 'Total'
    }
  },
  zh: {
    sellingCostDetail: {
      queryCondition: '查询条件',
      sellingCostDetail: '销售成本明细',
      productId: '商品编号',
      productName: '商品名称',
      barCode: '条码',
      totalAmount: '金额',
      returnCartNum: '退货数量',
      returnPayPrice: '退货金额',
      actualCartNum: '实售数量',
      salesRevenue: '销售收入',
      salesCost: '成本',
      grossMargin: '毛利',
      lossAmount: '亏损金额',
      createTime: '创建时间',
      total: '总计'
    }
  }
}